/**
 * proposalFormat - Utilitários de formatação da landing pública de propostas
 *
 * Centraliza formatação monetária, datas e cálculo de validade para que
 * todos os blocos visuais da landing exibam a mesma informação.
 *
 * @version 1.0.0
 * RELEASE: 2026-08-11 v1.0.0 - Criação inicial (redesign premium da landing /p/:token)
 */

/** Formata valores monetários em pt-BR */
export function formatCurrency(value: number | null | undefined, currency = 'BRL'): string {
  if (value === null || value === undefined) return '—';
  return Number(value).toLocaleString('pt-BR', { style: 'currency', currency });
}

/** Formata data curta (dd/mm/aaaa) */
export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('pt-BR');
}

/** Formata data e hora curtas */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  return new Date(value).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Calcula quantos dias faltam até a expiração da proposta.
 * Retorna null quando não há data de validade definida.
 */
export function daysUntil(value: string | null | undefined): number | null {
  if (!value) return null;
  const target = new Date(value).getTime();
  if (Number.isNaN(target)) return null;
  const diffMs = target - Date.now();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

/** Texto amigável de urgência da validade (gatilho de escassez) */
export function validityLabel(days: number | null): string | null {
  if (days === null) return null;
  if (days < 0) return 'Prazo encerrado';
  if (days === 0) return 'Último dia de validade';
  if (days === 1) return 'Válida por mais 1 dia';
  return `Válida por mais ${days} dias`;
}
